// extracted by mini-css-extract-plugin
export var contentCardsContainer = "BeforeAfterSection-module--contentCardsContainer--06ec1";
export var extraContentCardStyle = "BeforeAfterSection-module--extraContentCardStyle--070f1";
export var sectionContainer = "BeforeAfterSection-module--sectionContainer--6db23";